import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { IntegrationSystem, ModelType } from "@biteinc/enums";
import { I9nSchemaBySystem } from "@biteinc/common";
//#region src/utils/integration_utils.ts
var integration_utils_exports = /* @__PURE__ */ __exportAll({
	getI9nDiningOption: () => getI9nDiningOption,
	getI9nSchema: () => getI9nSchema,
	getSyncedProp: () => getSyncedProp,
	isOtpEligibleMethod: () => isOtpEligibleMethod,
	resolveOtpEligibleAuthMethods: () => resolveOtpEligibleAuthMethods,
	syncsModelsWithType: () => syncsModelsWithType
});
function getI9nDiningOption(data, fulfillmentMethod) {
	return data.diningOptions?.find((diningOption) => {
		return diningOption.fulfillmentMethod === fulfillmentMethod;
	});
}
function getI9nSchema(data) {
	return I9nSchemaBySystem[data.system];
}
function getSyncedProp(data, property) {
	return (data.syncedData || {})[property];
}
function syncsModelsWithType(data, modelType, throwOnUnsyncableModelType = true) {
	const i9nSchema = getI9nSchema(data);
	if (i9nSchema.type !== "pos") return false;
	switch (modelType) {
		case ModelType.Badge: return !!i9nSchema.syncsBadges && !!data.syncBadges;
		case ModelType.Mod:
		case ModelType.ModGroup:
		case ModelType.MenuItem: return true;
		case ModelType.MenuSection: return !!i9nSchema.syncsSections && !!data.syncSections;
		case ModelType.MenuStructure: return !!i9nSchema.syncsMenuStructures && !!data.syncMenuStructures;
		case ModelType.TaxProfile: return !!i9nSchema.syncsTaxes;
		case ModelType.OpenHoursTimetable: return !!i9nSchema.syncsOpenHoursTimetables;
		case ModelType.OpenHoursOverride: return !!i9nSchema.syncsOpenHoursOverrides;
		case ModelType.IntegrationSupplementaryData: return !!i9nSchema.syncsSupplementaryData;
		default:
			if (throwOnUnsyncableModelType) throw new Error(`No one syncs ${modelType}`);
			return false;
	}
}
const OTP_DISABLED = [];
/**
* Configured `authMethods` intersected with what the provider supports
* (`schema.otpEligibleAuthMethods`, absent = no OTP). Config-validity (e.g. Olo's
* `oloAuthChannelId`) is the validator's save-time concern, NOT re-checked here.
* `PinataLoyalty` keeps a runtime `enableOtp` gate for the e2e suite.
*/
function resolveOtpEligibleAuthMethods(input) {
	if (!input) return OTP_DISABLED;
	const schema = getI9nSchema(input);
	const supportedMethods = schema.type === "loyalty" && "otpEligibleAuthMethods" in schema && Array.isArray(schema.otpEligibleAuthMethods) ? schema.otpEligibleAuthMethods : void 0;
	if (!supportedMethods) return OTP_DISABLED;
	if (input.system === IntegrationSystem.PinataLoyalty && !input.enableOtp) return OTP_DISABLED;
	return (input.authMethods ?? []).filter((method) => supportedMethods.includes(method));
}
/** Whether OTP can verify `method` here; `false` when OTP is off (empty list). */
function isOtpEligibleMethod(eligibleMethods, method) {
	return eligibleMethods.includes(method);
}
//#endregion
export { getI9nDiningOption, getI9nSchema, getSyncedProp, integration_utils_exports, isOtpEligibleMethod, resolveOtpEligibleAuthMethods, syncsModelsWithType };

//# sourceMappingURL=integration_utils.js.map